


































































































































































































































































































































































































































































































































































































































import BaseEdit from './BaseEdit';
import DonorForm from './DonorForm.vue';
import { Component, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import DonorService from '../../services/donor.service.js';
import ServicesAndBills from '../../components/ServicesAndBills.vue';
import DonorAtWork from '../../models/donorAtWork';
import printJS from 'print-js';
import Constants from '../../constants';
import PrintInfectionsStatusModal from '@/pages/donors/PrintInfectionsStatusModal.vue';
import TcEdit from './TcEdit.vue';
import moment from 'moment';
import FileUploader from '@/components/FileUploader.vue';

@Component({
  components: {
    'services-and-bills': ServicesAndBills,
    PrintInfectionsStatusModal,
    TcEdit,
    DonorForm,
    'file-uploader': FileUploader
  },
})
export default class Edit extends BaseEdit {
  form = new DonorAtWork();
  tabIndex = 0;

  collectionCenters: any[] = [];
  initTransfusiologist = false;
  deletedRejreasonId: any = '';
  isShownInfectionsModal: any = false;
  infectionsResult: any = {};
  ctFile: File | null = null;

  isGskTemplateFormAccessible: any = false;
  moment = moment;
  transfusiologists: any[] = [];
  transfusiologistsSelect: any[] | null = [];
  files: any[] = [];

  get hasIon() {
    return window.ion;
  }
  protected created() {
    DonorService.loadCollectionCenters(this);
  }

  async submitWithFile(path: any, isGoBack = false, routeBackName: any = '') {
    let formData = new FormData();
    formData.append('ctFile', this.ctFile as File);
    formData.append('json', JSON.stringify(this.form));

    await this.submit(
      path,
      isGoBack,
      routeBackName,
      formData,
      this.showStatusChangeError
    );
    this.initTransfusiologist = false;
    //@ts-ignore
    this.$refs.donorForm.save();
  } 

  requestDateChanged(date: any) {
    this.form.requestDate = date;
  }

  onFilesUpdated(files: any) {
    this.files = files;

    let fileType = this.$t('Согласие донора на донацию');
    //@ts-ignore
    this.$refs.ctFileInfo.clearFiles();
    this.form.ctFileInfo = files.find((t: any) => t.fileTypeName == fileType);    
  }

  @Watch('form.operatorId')
  onOperatorIdChanged(val: string, oldVal: string) {
    let operator: any = this.form.operatorsData.find(
      (column: any) => column.id == val
    );
    if (operator) {
      this.form.operatorName = operator.name;
      this.form.operatorEmail = operator.email;
      // @ts-ignore
      this.$refs.operatorPhone.clearPhone();
      // @ts-ignore
      this.$refs.operatorAdphone.clearPhone();
      this.form.operatorPhone = operator.phone;
      this.form.operatorAdphone = operator.additionalPhone;
    }    
  }

  @Watch('form.collectionCenterId')
  onCollectionCenterIdChanged(val: any, oldVal: any) {
    const colCenter = this.collectionCenters.find((x: any) => x.key == val);
    this.form.collectionCenterName = colCenter != null ? colCenter.value : '';
    this.transfusiologists = this.form.transfusiologists.filter(
      (column: any) => column.organizationId == val
    );
    let transfusiologist;
    if (this.transfusiologists && this.transfusiologists.length > 0) {
      if (this.transfusiologists.length > 1) {
        this.transfusiologistsSelect = this.transfusiologists.map((x: any) => ({
          key: x.id,
          value: x.name
        }));
      }
      transfusiologist =
        this.transfusiologists.find(
          t => t.id == this.form.transfusiologistId
        ) || this.transfusiologists.find(() => true);
    } else {
      this.transfusiologistsSelect = null;
    }
    this.updateTransfusiologistFields(transfusiologist);
  }

  onChangeTransfusiologist(val: any, oldVal: any) {
    let transfusiologist = this.transfusiologists.find(t => t.id == val);
    this.updateTransfusiologistFields(transfusiologist);
  }

  updateTransfusiologistFields(transfusiologist: any) {
    this.form.transfusiologistId =
      (transfusiologist && transfusiologist.id) || "";
    if (this.initTransfusiologist) {
      this.form.transfusiologistName =
        (transfusiologist && transfusiologist.name) || "";
      this.form.transfusiologistEmail =
        (transfusiologist && transfusiologist.email) || "";
      // @ts-ignore
      this.$refs.transfusiologistPhone.clearPhone();
      // @ts-ignore
      this.$refs.transfusiologistAdphone.clearPhone();
      this.form.transfusiologistPhone =
        (transfusiologist && transfusiologist.phone) || "";
      this.form.transfusiologistAdphone =
        (transfusiologist && transfusiologist.additionalPhone) || "";
    }

    this.initTransfusiologist = true;
  }

  get canSetPriority() {
    return (
        this.$auth.user().functions.find((t: any) => t.routeName === "SetDonorPriority") != null
    );
  }

  get isTransfusiologistSelectListVisible() {
    return (
      this.transfusiologistsSelect && this.transfusiologistsSelect.length > 0
    );
  }

  @Watch("form.rejreasonId")
  onRejreasonIdChanged(val: string, oldVal: string) {
    if (oldVal === 'init') return;

    if (this.form.rejectionReasons) {
      let rejReason: any = this.form.rejectionReasons.find(
        (x: any) => x.id === val
      );
      this.isTemporary = rejReason && rejReason.isTemporary;
      // if (rejReason) {
      //   this.setDonorStatus(
      //     rejReason.isTemporary ? 'Отказ РегВрем' : 'Отказ регистра'
      //   );
      // } else {
      //   this.setDonorStatus(this.loadedStatus.value);
      // }
    }
  }

  async onStatusChanged(value: any) {
    if(this.form.status == value) return;
    //@ts-ignore
    if(this.form.status > value && !(this.form.status == 16 && value == 9) || [3,4,5,6,16].includes(value)) {
      //@ts-ignore
      let newStatusName = this.form.statuses.filter(s => s.key == value)[0].value;
    let msgText = '<span style="color:black; font-size: 18px">Это действие отменит текущий статус. <br/>Будет выставлен предыдущий статус <b>"' + newStatusName + '"</b>. <br/>Выполнить операцию?</span>';
      if([3,4,5,6].includes(value)) {
        msgText = '<span style="color:black; font-size: 18px">Вы действительно хотите сделать <span style="color:red">ОТКАЗ</span>? <br/>В результате будет выставлен статус <b>"' + newStatusName + '"</b>. <br/> Выполнить операцию?</span>';
      }
      const msgHtml = document.createElement("div");
      msgHtml.innerHTML = msgText;
      //@ts-ignore
      this.$swal({
        icon: 'warning',
        title: this.$t('Предупреждение'),
         content: msgHtml,
        buttons: [this.$t('Нет'), this.$t('Да')],
      }).then(async (doChange: any) => {
        if (doChange) {
          const status = this.getStatusByKey(value);
          const oldStatus = this.form.status;
          this.form.status = status.key;
          await this.submitWithFile('/donorsatwork');
          if (this.isStatusChangeError) {
            this.form.status = oldStatus;
      }
        }
      });
    } else {
      const status = this.getStatusByKey(value);
      const oldStatus = this.form.status;
      this.form.status = status.key;
      await this.submitWithFile('/donorsatwork');
      if (this.isStatusChangeError) {
        this.form.status = oldStatus;
      }
    }
    // this.setTimeout(status);
  }

  get isCtStatus() {
    return this.loadedStatus && !this.loadedStatusIn(['Подбор', 'Ожидание Центра']);
  }

  get ctDirectionUrl() {
    return `/DonorsAtWork/ExportHlaTyping?donorid=${this.form.id}&userId=${this.$auth.user().id}&patientId=${this.form.patientId}`;
  }

  onAddInfectionsResult() {
    //@ts-ignore
    this.$refs.uploader.fetchData(true);
    this.infectionsResult = JSON.parse(JSON.stringify(this.form.infectionsResult));
  }  

  get gskTemplateUrl() {

    if (
      this.form.medicalExamination &&
      this.form.collectionDate &&
      this.form.collectionMethodId
    ) {
      let medicalExamination = this.form.medicalExamination instanceof Date ? this.form.medicalExamination.toJSON() : new Date(this.form.medicalExamination).toJSON();
      let collectionDate = this.form.collectionDate instanceof Date ? this.form.collectionDate.toJSON() : new Date(this.form.medicalExamination).toJSON();
      return `${Constants.baseUrl}/DonorsAtWork/GskTemplateForm?donorid=${this.form.id}
              &userId=${this.$auth.user().id}&medicalExamination=${medicalExamination}
              &collectionDate=${collectionDate}&collectionMethodId=${this.form.collectionMethodId}
              &patientId=${this.form.patientId}`;
    } else {
      return null;
    }
  }

  generateGskTemplateUrl() {
    var errors = "";

    if(!this.form.medicalExamination) errors += "</br><strong>" + this.$t('Дата обследования и консультации донора') + "</strong>";
    if(!this.form.collectionDate) errors += "</br><strong>" + this.$t('Согласованная дата сбора клеток') + "</strong>";
    if(!this.form.collectionMethodId) errors += "</br><strong>" + this.$t('Согласованный метод сбора клеток (костный мозг/СКПК)') +"</strong>";

    //@ts-ignore
    this.highlightAllLabels(errors);

    if(errors.length != 0)
    {
      Swal(this.$t('Предупреждение') + '',
           this.$t('Нельзя создать файл `Расписание заготовки ГСК` без указания') + `: ${errors}`,
           'warning');
    }
  }

  get isPrintDirectionAccessible() {
    return this.loadedStatusIn(['Подбор']);
  }

  get isPrintGskTemplateAccessible() {
    return this.loadedStatusIn(['Активация']);
  }

  get isPrintInfectionsStatusAccessible() {
    return this.loadedStatusIn(['CT']);
  }

  get inEmptyStatus() {
    return this.isDataLoaded && !this.loadedStatus;
  }

  get isWaitRdkmDisabled() {
    return this.loadedStatus && this.loadedStatus.value !== 'CT';
  }

  protected clearDate() {
    this.form.hlaDate = null;
    this.form.ctOrderDate = null;
    this.form.ctSendDate = null;
    this.form.idmSendDate = null;
    this.form.ctRecieveDate = null;
  }

  protected setDonorStatus(statusName: String) {
    // this.isTemporary = statusName === 'Отказ РегВрем' ? true : false;
    const donorStatus = this.getStatusByName(statusName);

    if (donorStatus) {
      this.form.status = donorStatus.key;
      if (
        this.statusIn(['Дополнение', 'Подбор', 'CT', 'Ожидание Центра', 'Готов'])
      ) {
        this.form.timeout = this.getTimeout();
        this.form.startStatus = new Date();
      } else {
        this.form.timeout = this.initTimeout;
      }
    }
  }

  get isActivationPartVisible() {
    return this.$auth.user().isLr && this.statusIn(['Активация', 'Готов']);
  }

  get isActivationDisabled() {
    return !this.loadedStatusIn(['Активация']) || this.$auth.user().isRdkm;
  }

  get isDisabledOperator() {
    if(this.canSetPriority) {
      return false;
    }
    return this.$auth.user().isRdkm || !this.statusIn(['Подбор', 'Активация']);
  }

  get isCommentDisabled() {
    return (
      (this.$auth.user().isRdkm && !this.statusIn(['Подбор', 'Ожидание Центра'])) ||
      this.$auth.user().isLr
    );
  }

  get rejectionDateRequire() {
    //return this.isTemporary ? 'required' : '';
    return '';
  }

  @Watch('form.collectionDate')
  onCollectionDate(val: number, oldVal: number) {
    this.isGskTemplateFormAccessible = val && !oldVal;
  }

  @Watch('isDataLoaded')
  onIsDataLoaded() {
    if(this.isDataLoaded) {
      this.infectionsResult = JSON.parse(JSON.stringify(this.form.infectionsResult));
    }

    if(this.isDataLoaded && !this.form.operatorId && this.$auth.user().isLr)
    {
      this.form.operatorId = this.$auth.user().id;
    }
  }

  get isRejectionReasonIsDisabled() {
    return (
      this.$auth.user().isRdkm ||
      !this.statusIn([
        'CT',
        'Подбор',
        'Активация',
        'Отказ РегВрем',
        'Отказ регистра',
        'Отказ Центра',
      ])
    );
  }

  get showBackToPatient() {
    return !this.$auth.user().isLr && this.form.patientId;
  }
}
